var _path, _path2, _path3, _path4, _line, _line2, _rect, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetric2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 127,
    viewBox: "0 0 260 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5H231.909L255 21.4971V101.817L228.232 122H57.0346L27 105.309V5Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4317 79.1215V91.768C24.4317 99.8217 28.3369 107.376 34.9079 112.032L45.3438 119.428C49.5414 122.402 54.5593 124 59.7042 124H134.163",
    stroke: "black",
    strokeWidth: 4.73078
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 77.4594V92.1082C257.422 100.886 252.789 109.012 245.234 113.483L233.312 120.538C229.482 122.804 225.113 124 220.663 124H156.71",
    stroke: "black",
    strokeWidth: 4.73078
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.88 49.4904V34.5569C256.88 26.0728 252.549 18.1756 245.396 13.6146L235.428 7.25958C231.439 4.71636 226.807 3.36528 222.076 3.36528H164.238",
    stroke: "black",
    strokeWidth: 4.73078
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.36539,
    x2: 57.9519,
    y2: -2.36539,
    transform: "matrix(-0.00624449 -0.999981 0.999995 -0.00307861 27.8004 58.951)",
    stroke: "black",
    strokeWidth: 4.73078
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.9352,
    y1: 3.06766,
    x2: 120.62,
    y2: 3.06766,
    stroke: "black",
    strokeWidth: 4.73078
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.45614,
    y: 33.4561,
    width: 51.0877,
    height: 51.0877,
    rx: 6.8421,
    fill: "url(#paint0_linear_13_71)",
    stroke: "url(#paint1_linear_13_71)",
    strokeWidth: 0.912281
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7246 70.3718V60.4824C20.7246 58.6618 19.2733 57.1859 17.4831 57.1859H14.2415C12.4513 57.1859 11 58.6618 11 60.4824V70.3718C11 72.1924 12.4513 73.6683 14.2415 73.6683H17.4831C19.2733 73.6683 20.7246 72.1924 20.7246 70.3718ZM20.7246 70.3718V53.8894C20.7246 52.0688 22.1759 50.5929 23.9661 50.5929H27.2076C28.9979 50.5929 30.4492 52.0688 30.4492 53.8894V70.3718M20.7246 70.3718C20.7246 72.1924 22.1759 73.6683 23.9661 73.6683H27.2076C28.9979 73.6683 30.4492 72.1924 30.4492 70.3718M30.4492 70.3718V47.2965C30.4492 45.4759 31.9004 44 33.6907 44H36.9322C38.7224 44 40.1737 45.4759 40.1737 47.2965V70.3718C40.1737 72.1924 38.7224 73.6683 36.9322 73.6683H33.6907C31.9004 73.6683 30.4492 72.1924 30.4492 70.3718Z",
    stroke: "white",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_71",
    x1: 26,
    y1: 33,
    x2: 26,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_71",
    x1: 7.83611,
    y1: 33.6855,
    x2: 55.9892,
    y2: 69.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric2);
export default __webpack_public_path__ + "static/media/metric-2.9de715217b2881552beed2bf0a7d5633.svg";
export { ForwardRef as ReactComponent };